import {FC, ReactNode} from 'react';


import './Modal.scss'
import Button from "../../atoms/Button/Button";
import CloseIcon from "../../icons/CloseIcon";


interface IModal {
    className?: string;
    header?: ReactNode;
    children: ReactNode;
    active: boolean;
    onAccept?: () => void;
    onCancel?: () => void;
    onClose: () => void;
    controls?: boolean
}

const Modal:FC<IModal> = ({className='',active,controls=false,header,children,onClose,onAccept,onCancel}) => {
    return (
        <div className={`modal ${active ? "active": ""}`}>
            <div className={`modal__wrap ${className}`}>
                <div className="modal__close" onClick={onClose}><CloseIcon/></div>
                <div className="modal__body">
                    <div className="modal__title">{header}</div>
                    <div className="modal__description">
                        {children}
                    </div>
                    {controls ?<div className="modal__content">
                        <div className="modal__info">
                            <div className="modal__buttons">
                                <div className="modal__confirm">
                                    <Button onClick={onAccept} className={'btn--primary modal__btn'} name={'Да'}/>
                                    <Button color="red" onClick={onCancel} className={'btn--primary modal__btn'} name={'Отменить'}/>
                                </div>
                            </div>
                        </div>
                    </div> : ""}
                </div>
            </div>
        </div>
    );
};

export default Modal;